<template>
<div>
   <div class="nav-pagination">
            <div class="container">
               <hr class="hraing">
               <div class="row">
                  <div class="col-md-6 col-sm-6">
                     <div class="sooper-text">
                        <h4>White Label Business Intelligence Platform</h4>
                     </div>
                  </div>
                  <div class="col-md-6  col-sm-6 text-right nav-pagination1">
                     <ul>
                        <li><a href="index.html">Company</a></li>
                        <li> |
                        </li>
                        <li>White Label Business Intelligence Platform</li>
                     </ul>
                  </div>
               </div>
            </div>
         </div>

 <section class="discover-analytics">
         <div class="container">
            <div class="row">
               <div class="col-md-6 col-sm-6">
                  <div class="right-text  wow animated slideInLeft">
                     <h1>White Label Business Intelligence Platform</h1>
                     <h4>Leverage your data</h4>
                     <p>Need to ensure that there is secure access to a single source of truth for everyone? The key to insightful analysis is the data. We collect, enrich and manage as much data as you need.</p>
                     <div class="button-center ">
                       <router-link to="/Contact"> <a class="btn button3">Get Started</a></router-link>
                     </div>
                  </div>
               </div>
               <div class="col-md-6 col-sm-6">
                  <div class="wow animated zoomIn">
                     <img src="../image/Vectors/Trending-ResearchDAC-01.svg" class="img-responsive" alt="desktop">
                  </div>
               </div>
               <div class="col-md-12 col-sm-12">
                  <div class=" wow animated zoomIn">
                     <br>
                     <br>
                  </div>
               </div>
            </div>
            <div class="row">
               <div class="col-md-2">
                  <div class="wow animated zoomIn">
                     <center><img src="../image/Icons/Bar chart.png" class="img-responsive img-service-page" alt="desktop"></center>
                  </div>
               </div>
               <div class="col-md-4">
                   <div class="right-text  wow animated slideInLeft">
                     <h4>Bespoke Analytics</h4>
                     <p>The info you need at your fingertips wherever you are. Our analytics give you insights needed to minimise risk in decision making, helping to discover hidden opportunities.</p>
                  </div>
               </div>
               <div class="col-md-2">
                  <div class="wow animated zoomIn">
                     <center><img src="../image/Icons/Dash with magnifying glass.png" class="img-responsive img-service-page" alt="desktop"></center>
                  </div>
               </div>
               <div class="col-md-4">
                   <div class="right-text  wow animated slideInLeft">
                     <h4>Align with your brand</h4>
                    <p>Our platform is white-labelled to align with your corporate colours and branding! Ready to share with colleagues, prospective clients and any other stakeholders.</p>
                  </div>
               </div>
            </div>
            <br>
                     <hr>
                     <br>
         </div>
         <section v-show="size === false" class="screenshot">
         <div class="container">
            <div class="row">
               <div class="col-md-12 col-sm-12">
                  <div class="heading text-center wow animated slideInUp">
                     <h3>Some Examples Of Our Work</h3>
                  </div>
               </div>
            </div>
         </div>

         <div class="container">
            <div>
            <carousel :perPage="1" navigationEnabled autoplay autoplayTimer="2000" paginationColor="#787878" paginationActiveColor="#f2be1e">
               <slide>
                  <center>
                  <div class="item active">
                           <img src="../image/Dashboards/Correlatiom dash grey.png" class="img-responsive img-slider img-rounded"  alt="image">
                           <div class="carousel-caption">
                           </div>
                  </div>
                  </center>
               </slide>
                <slide>
                  <center>
                  <div class="item">
                           <img src="../image/Dashboards/Silicone fen dash grey.png" class="img-responsive img-slider img-rounded"  alt="image">
                           <div class="carousel-caption">
                           </div>
                  </div>
                  </center>
               </slide>
               <slide>
                  <center>
                 <div class="item">
                           <img src="../image/Dashboards/EJ Dash grey.png" class="img-responsive img-slider img-rounded " alt="image">
                           <div class="carousel-caption">
                           </div>
                  </div>
                  </center>
               </slide>
            </carousel>
         </div>
         </div>

      </section>
         <div class="container">
            <div class="row">
               <div class="col-md-12 col-sm-12">
                  <div class="heading text-center wow animated slideInUp">
                     <h3>Features</h3>
                  </div>
               </div>
               <div class="col-md-4 col-sm-6">
                  <router-link to="/Contact">
                  <div class="feature-text text-center  wow animated slideInLeft">
                     <div class="img-kpi"></div>
                     <h4>Centralised Data</h4>
                     <p>One source of truth for your whole organisation, empowering your teams to thrive.</p>
                     <a>Get Started</a>
                  </div>
                  </router-link>
               </div>
               <div class="col-md-4 col-sm-6">
                  <router-link to="/Contact">
                  <div class="feature-text text-center wow animated slideInUp">
                     <div class="img-dash"></div>
                     <h4>Open Text Q & A</h4>
                     <p>No more making requests for figures, use plain text to create analysis’ on the fly.</p>
                     <a>Get Started</a>
                  </div>
                  </router-link>
               </div>
               <div class="col-md-4 col-sm-6">
                  <router-link to="/Contact">
                  <div class="feature-text text-center wow animated slideInRight">
                     <div class="img-event"></div>
                     <h4>Drill Down</h4>
                     <p>Filter and Sort your data to understand exactly what’s happening in any area.</p>
                     <a>Get Started</a>
                  </div>
                  </router-link>
               </div>
               </div>
            <div class="row">
               <div class="col-md-4 col-sm-6">
                  <router-link to="/Contact">
                  <div class="feature-text text-center wow animated slideInLeft">
                     <div class="img-client"></div>
                     <h4>Client Reporting</h4>
                     <p>An affordable way to share branded reports and dashboards with clients, investors and other stakeholders.</p>
                     <a>Get Started</a>
                  </div>
                  </router-link>
               </div>

               <div class="col-md-4 col-sm-6">
                  <router-link to="/Contact">
                  <div class="feature-text text-center wow animated slideInUp">
                     <div class="img-custom"></div>
                     <h4>Custom Visualisations</h4>
                     <p>Don't rely on prebuilt graphs, we develop custom visuals to meet your needs.</p>
                     <a>Get Started</a>
                  </div>
                  </router-link>
               </div>


               <div class="col-md-4 col-sm-6">
                  <router-link to="/Contact">
                  <div class="feature-text text-center wow animated slideInRight">
                     <div class="img-alert"></div>
                     <h4>Data Driven Alerts</h4>
                     <p>Always know what’s happening in your organisation with customisable data driven alerts.
                     </p>
                     <a>Get Started</a>
                  </div>
                  </router-link>
               </div>
               <div class="col-md-12 no-padding">
                  <div class="heading text-center">
                     <br>
                     <h3>What our customers think about</h3>
                     <br>
                     <h3>Discovr Analytics</h3>
                  </div>
               </div>

               <div class="col-md-4 col-sm-12">

                   <div class="quest-text1 wow animated slideInLeft">
                     <div class="img-hover9"></div>
                     <p
                       class="line"
                     >The Discovr team has been a great pleasure to work with - always responsive to my many queries and requests, as well as coming up with realistic suggestions on how we analyse/visualise our data.</p>
                     <hr class="border-hr" />
                     <img
                       src="../image/client-logos/ResetHealthLogo.png"
                       class="img-testimonial"
                       alt="testimonial"
                     />
                     <h5>
                       <a href="#">Dr Ling C | Head of Operations, Reset Health</a>
                     </h5>

                   </div>

               </div>
               <div class="col-md-4 col-sm-12">
                    <router-link to="/Case-Study/Machine%20Learning%20for%20WorkPlace%20Buzz?post_id=439vIex7RTKByrUfH5v3H0"> <div class="quest-text1 wow animated slideInUp">
                        <div class="img-hover9"></div>
                        <p class="line">Discovr Analytics has helped us to modernise our Engagement Survey Product's infrastructure allowing us to gain much more valuable insights for us and our customers.</p>
                        <hr class="border-hr">
                        <img src="../image/client-logos/WPB-logo.png" class="img-testimonial" alt="testimonial">
                        <h5><a href="#">Mark S PhD | Chief Psychologist,  WorkplaceBuzz</a></h5>
                        <a><br>Read Case Study</a>
                     </div></router-link>
               </div>
               <div class="col-md-4 col-sm-12">
                     <router-link to="/Case-Study/eDNA%20OTA%20and%20Meta%20Analysis%20for%20EasyJet?post_id=5Yix0Lb8ZNtYcIIPvWNHKd"><div class="quest-text1 wow animated slideInRight">
                        <div class="img-hover9"></div>
                        <p class="line">Discovr Analytics helped us develop and manage intuitive analytics for our customers - all hosted in their easy to use white-label business intelligence platform.</p>
                        <hr class="border-hr">
                        <img src="../image/client-logos/edna-logo.png" class="img-testimonial" alt="testimonial">
                        <h5><a href="#">Jon S | Founder and Director,  eDNA Solutions</a></h5>
                        <a><br>Read Case Study</a>
               </div></router-link>
            </div>
         </div>
         </div>
      </section>
</div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
  name: 'Platform',
  metaInfo: {
      meta: [
      {name: 'description', content: 'Fully customisable white-label business intelligence platform for SMEs.'}
            ],
     htmlAttrs: {
      lang: 'en'
    },
      title: 'Discovr Analytics | Analytics Consulting & Development Company',
      // override the parent template and just use the above title only
      titleTemplate: null
    },
  data: function () {
    return {
      scrolled: true,
      size: null,
    }
  },
  components: {
    Carousel,
    Slide
  },
  created () {
     if (screen.width < 700) {
                  this.size = true;
                }
                else {
                 this.size = false;
                }
  },
  beforeDestroy() {
    window.analytics.page("Platform");
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
